// ============================================================
// components/common/ComingSoonPage.tsx
//
// "Coming soon to web" landing for features that live on iOS
// but aren't in the browser yet (/app/friends, /app/groups,
// /app/messages). The full experience is the App Store app;
// web surfaces are convenience additions.
// ============================================================
import { Link } from 'react-router-dom';

export const APP_STORE_URL = 'https://apps.apple.com/us/app/stash-social/id1595856058';

interface ComingSoonPageProps {
  /** Feature name shown in the heading, e.g. "Messages". */
  feature: string;
  /** Optional emoji shown above the heading. */
  icon?: string;
}

export function ComingSoonPage({ feature, icon = '🚧' }: ComingSoonPageProps): React.JSX.Element {
  return (
    <div className="mx-auto flex w-full max-w-md flex-col items-center gap-4 px-6 py-16 text-center">
      <span aria-hidden className="text-4xl">{icon}</span>
      <h1 className="m-0 text-2xl font-semibold text-foreground">{feature}</h1>
      <p className="m-0 rounded-full bg-[var(--stash-blue-light)] px-4 py-1 text-sm font-semibold text-[var(--stash-blue-dark)]">
        Coming soon to web
      </p>
      <p className="m-0 text-sm leading-relaxed text-muted-foreground">
        The best experience and full features — including {feature.toLowerCase()} — are in the
        STASH Social app for iPhone and iPad. Browser features are being added for convenience.
      </p>
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="rounded-full bg-primary px-6 py-3 font-semibold text-primary-foreground transition-colors hover:bg-[var(--stash-blue-dark)]"
      >
        📱 Get STASH on the App Store
      </a>
      <Link to="/app/stashboard" className="text-sm font-medium text-[var(--stash-blue)] underline-offset-2 hover:underline">
        Back to your STASH Board
      </Link>
    </div>
  );
}
